import { AudioFormats, DocumentFormats, ImageFormats, VideoFormats, validExtensions } from '../models/file-formats.enums';

export const getImageFormats = (): string => Object.values(ImageFormats).join(',');

export const getVideoFormats = (): string => Object.values(VideoFormats).join(',');

export const getAudioFormats = (): string => Object.values(AudioFormats).join(',');

export const getDocumentFormats = (): string => Object.values(DocumentFormats).join(',');

const validExtensionsString = validExtensions.map((ext) => `.${ext}`).join(',');

// eslint-disable-next-line newline-per-chained-call
export const getAllFormats = (): string => getImageFormats().concat(',', getVideoFormats(), ',', getAudioFormats(), ',', getDocumentFormats()).toLowerCase();

export const getAllFormatsAndExtensions = (): string =>
  // eslint-disable-next-line newline-per-chained-call
  getImageFormats().concat(',', getVideoFormats(), ',', getAudioFormats(), ',', getDocumentFormats(), ',', validExtensionsString).toLowerCase();

export const isExtensionAllowed = (ext: string): boolean => validExtensions.includes(ext);
